import { Dropdown } from "primereact/dropdown";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { ModelTabOption } from "./types";
import styles from "./CatCard.module.css";

type ModelOption = { label: string; value: string };

type CatModelSwitcherProps = {
  selectedModel: ModelTabOption;
  onChange: (model: ModelTabOption) => void;
  isMobile: boolean;
  nearmapTabEnabled: boolean;
};

/**
 * Model picker for the Modeling tab. A SelectButton group on desktop, a compact
 * Dropdown on phones — same options either way.
 */
export const CatModelSwitcher = ({
  selectedModel,
  onChange,
  isMobile,
  nearmapTabEnabled,
}: CatModelSwitcherProps) => {
  const options: ModelOption[] = [
    { label: "RMS", value: "rms_elt" },
    { label: "RMS 22", value: "rms_22" },
    { label: "KatRisk", value: "spatialkat" },
    { label: "ICM", value: "icm_ylt" },
    { label: "ICM (Legacy)", value: "icm" },
    { label: "Rater", value: "rater" },
    ...(nearmapTabEnabled ? [{ label: "Nearmap", value: "nearmap" }] : []),
  ];

  const itemTemplate = (option: ModelOption) => (
    <span className={styles.modelOption}>
      {option.label}
      {option.value === "icm_ylt" && (
        <Tag value="Beta" severity="info" className={styles.betaTag} />
      )}
    </span>
  );

  return isMobile ? (
    <Dropdown
      value={selectedModel}
      onChange={(e) => e.value && onChange(e.value)}
      options={options}
      optionLabel="label"
      optionValue="value"
      itemTemplate={itemTemplate}
      className={styles.modelDropdown}
    />
  ) : (
    <SelectButton
      value={selectedModel}
      onChange={(e) => e.value && onChange(e.value)}
      options={options}
      itemTemplate={itemTemplate}
    />
  );
};
